import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const organizationPageContext = React.createContext({});
export let organizationPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMOrganizationPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  organizationPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(organizationPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    organizationPageMachine,
    organizationPageState: state,
    organizationPageSend: send,
  };
};
